module.exports = __webpack_public_path__ + "img/mainFunction-icon4.b338e42c.png";